import React from "react";
import { trackGoogleAdsConversion } from "../lib/googleAds";

const WHATSAPP_URL =
  "https://wa.me/33651885745?text=" +
  encodeURIComponent("Bonjour CAB CITY, je souhaite réserver un trajet.");

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      onClick={() => trackGoogleAdsConversion({ type: "whatsapp" })}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacter CAB CITY sur WhatsApp"
      title="Contacter CAB CITY sur WhatsApp"
      className="fixed bottom-5 right-5 z-[9990] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-200 hover:scale-110 focus:outline-none focus:ring-4 focus:ring-[#25D366]/40 md:bottom-6 md:right-6"
    >
      <svg
        viewBox="0 0 32 32"
        aria-hidden="true"
        className="h-8 w-8 fill-current"
      >
        <path d="M19.11 17.37c-.29-.15-1.7-.84-1.96-.94-.26-.1-.45-.15-.64.15-.19.29-.74.94-.91 1.13-.17.19-.33.22-.62.07-.29-.15-1.21-.45-2.31-1.43-.85-.76-1.43-1.69-1.6-1.98-.17-.29-.02-.45.13-.6.13-.13.29-.33.43-.5.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.15-.64-1.55-.88-2.12-.23-.56-.47-.48-.64-.49h-.55c-.19 0-.5.07-.76.36-.26.29-1 1-.1 2.43.9 1.43 1.03 1.71 2.57 3.26 1.54 1.55 3.75 2.18 4.28 2.29.53.11 1.65.1 2.28-.38.63-.48.88-1.19.88-1.19.1-.17.1-.31.07-.43-.03-.12-.17-.19-.46-.34z" />
        <path d="M16.02 3.2c-7.08 0-12.83 5.75-12.83 12.83 0 2.26.59 4.38 1.63 6.22L3.1 28.8l6.72-1.67a12.78 12.78 0 0 0 6.2 1.59h.01c7.08 0 12.83-5.75 12.83-12.83S23.1 3.2 16.02 3.2zm0 23.4h-.01a10.54 10.54 0 0 1-5.37-1.47l-.39-.23-3.99.99 1.07-3.89-.25-.4a10.57 10.57 0 1 1 8.94 5zm6.02-7.92c-.33-.17-1.94-.96-2.24-1.07-.3-.11-.52-.17-.74.17-.22.33-.85 1.07-1.04 1.29-.19.22-.38.25-.71.08-.33-.17-1.39-.51-2.65-1.63-.98-.87-1.64-1.95-1.83-2.28-.19-.33-.02-.51.14-.67.15-.15.33-.38.49-.57.16-.19.22-.33.33-.55.11-.22.05-.41-.03-.57-.08-.17-.74-1.78-1.01-2.44-.27-.65-.54-.56-.74-.57h-.63c-.22 0-.57.08-.87.41-.3.33-1.14 1.12-1.14 2.73s1.17 3.17 1.34 3.39c.17.22 2.3 3.51 5.57 4.92.78.34 1.39.54 1.87.69.79.25 1.51.21 2.08.13.64-.1 1.94-.79 2.21-1.55.27-.76.27-1.41.19-1.55-.08-.14-.3-.22-.63-.39z" />
      </svg>
    </a>
  );
}
